import Colors from '../../config/Colors';

const styles = {
    modal: {
        content: {
            padding: 0,
            width: 380,
            height: 'auto',
            borderRadius: 6,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            backgroundColor: Colors.darkerTransparent
        }
    },
    container: {
        textAlign: 'center',
        padding: 16
    },
    button: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        backgroundColor: Colors.secondary,
        marginHorizontal: 8,
        marginBottom: 8,
        borderRadius: 6
    },
    spaceFiller: {
        padding: 4
    },
    textModal: {
        fontSize: '1.6rem'
    }
};

export default styles;
